import { render, staticRenderFns } from "./deleteStoreAds.vue?vue&type=template&id=06d4f0ac"
import script from "./deleteStoreAds.vue?vue&type=script&lang=js"
export * from "./deleteStoreAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports